import { render, staticRenderFns } from "./COAInformation.vue?vue&type=template&id=f73433c6&scoped=true&"
import script from "./COAInformation.vue?vue&type=script&lang=js&"
export * from "./COAInformation.vue?vue&type=script&lang=js&"
import style0 from "./COAInformation.vue?vue&type=style&index=0&id=f73433c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73433c6",
  null
  
)

export default component.exports